import merge from 'lodash/merge.js';

import BaseRubrics from '@/store/modules/base/BaseRubrics.js';

export default merge(BaseRubrics({ name: 'RubricTemplates' }), {});
